//Install
import React, { Component } from "react";
//Install
import { ReactComponent as Facebook } from "../../Media/Social/001.svg";
//Install
import { ReactComponent as X } from "../../Media/Social/002.svg";
//Install
import { ReactComponent as Instagram } from "../../Media/Social/003.svg";
//Install
import { ReactComponent as YouTube } from "../../Media/Social/004.svg";
//Install
import { ReactComponent as Linkedin } from "../../Media/Social/005.svg";

//Element
class Social extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB z508i8" },
            //Element
            React.createElement("li", { className: "S6pt64" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "https://www.facebook.com/" },
                    //Element
                    React.createElement(Facebook, {})
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "https://x.com/" },
                    //Element
                    React.createElement(X, {})
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "https://www.instagram.com/" },
                    //Element
                    React.createElement(Instagram, {})
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "https://www.youtube.com/" },
                    //Element
                    React.createElement(YouTube, {})
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "https://tr.linkedin.com/" },
                    //Element
                    React.createElement(Linkedin, {})
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Social;